(function($, visceral) {

    if(visceral == null) {
        window.visceral = visceral = {}; 
    }

    var grid = null;
    var items = null;


    $(function () {
        init();
    });
    
    
    function init() {
        grid = $('.partners-grid');
        
        if(!grid.length) {
            return;
        }
        items = grid.find('.partners-grid__grid__item');

        grid.find('.partners-grid__filters select').change(function() {
            let filters = collect_filters();
            let matched = get_matching(filters);

            matched.removeClass('partners-grid--hidden');
            items.not(matched).addClass('partners-grid--hidden');
        });
    }

    function filters_to_classes(filters) {
        let classes = [];

        for(var key in filters) {
            if(filters[key] && filters[key] != null && filters[key] != '') {
                classes.push(`.partners-grid__grid__${key}--${filters[key]}`);
            }
        }
        
        return classes;
    }
    
    function collect_filters() {
        let filters = {};

        $('.partners-grid__filters select').each(function() {
            let select = $(this);
            filters[select.attr('name')] = select.val();
        });
        
        return filters;
    }
    
    function get_matching(filters) {

        let classes = filters_to_classes(filters);
        let matched = items
        
        classes.forEach(selector => {
            matched = matched.filter(function(index, element) { 
                return $(element).find(selector).length > 0;
            });
        }); 

        return matched;
    }
    
})(jQuery, window.visceral);


// WEBPACK FOOTER //
// ./scripts/partners-grid.js